import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import api from "../../../utils/axios";

const PhoneIcon = ({ size = 37, color = "#E13F57" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size * (38 / 37)} viewBox="0 0 37 38" fill="none">
    <path
      d="M9.89728 14.5229C11.2542 20.2801 14.7108 25.3236 19.5906 28.6664L20.3706 29.2212C21.2344 29.8353 22.2872 30.1248 23.3435 30.0387C24.3998 29.9526 25.3919 29.4965 26.1449 28.7506L27.602 27.308C27.8301 27.0817 27.9652 26.7782 27.9807 26.4572C27.9962 26.1362 27.8909 25.8211 27.6856 25.5739L24.5075 21.7454C24.3968 21.6121 24.2603 21.5026 24.1062 21.4234C23.9521 21.3442 23.7836 21.297 23.6108 21.2845C23.438 21.2721 23.2645 21.2947 23.1007 21.351C22.9368 21.4073 22.7861 21.4961 22.6574 21.6121L21.1631 22.9593C18.4484 20.8618 16.5004 17.9284 15.6202 14.6126L17.4402 13.7573C17.597 13.6837 17.7373 13.5792 17.8527 13.45C17.9682 13.3208 18.0563 13.1696 18.1118 13.0055C18.1673 12.8414 18.1891 12.6678 18.1759 12.4951C18.1626 12.3223 18.1146 12.1541 18.0347 12.0004L15.738 7.58633C15.5898 7.30124 15.3401 7.08201 15.0382 6.97182C14.7364 6.86163 14.4042 6.86848 14.1071 6.991L12.1998 7.77876C11.2145 8.18564 10.4057 8.92908 9.91733 9.87665C9.42901 10.8242 9.29293 11.9144 9.53332 12.9529L9.89728 14.5229Z"
      fill={color}
    />
  </svg>
);

export default function ContactModal({ isOpen, onClose, onSave, contact, customerType,ServiceAddr_Id, }) {
  const initialForm = {
    AR_ContactName: "",
    AR_ContactPosition: "",
    AR_Tel: "",
    AR_Mobile: "",
    AR_Email: "",
    AR_Line: "",
    ServiceAddr_Id: null,
  };

  const [formData, setFormData] = useState(initialForm);
  const [serviceName, setServiceName] = useState("");

  useEffect(() => {
    const formatTel = (num) => {
      let digits = (num || "").replace(/\D/g, "").slice(0, 10);

      //  มือถือ 10 หลัก → 000-000-0000
      if (digits.length === 10) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      }

      //  เบอร์บ้าน/สาธารณะ 9 หลัก → 00-000-0000
      if (digits.length === 9) {
        return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
      }

      //  เบอร์สั้นกว่านี้ระหว่างพิมพ์
      if (digits.length > 6) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      }

      if (digits.length > 3) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
      }

      return digits;
    };

    if (contact) {
      setFormData({
        AR_ContactName: contact.AR_ContactName || "",
        AR_ContactPosition: contact.AR_ContactPosition || "",
        AR_Tel: formatTel(contact.AR_Tel),
        AR_Mobile: formatTel(contact.AR_Mobile),
        AR_Email: contact.AR_Email || "",
        AR_Line: contact.AR_Line || "",
        ServiceAddr_Id: contact.ServiceAddr_Id || null,
      });
    } else {
      setFormData(initialForm);
    }
  }, [contact, isOpen]);

  useEffect(() => {
    const loadName = async () => {
      if (!ServiceAddr_Id) {
        setServiceName("");
        return;
      }

      try {
        const res = await api.get(`/get-tb-set-service-addr-by-id/${ServiceAddr_Id}`);
        const record = res.data?.result?.recordset?.[0];
        setServiceName(record?.ServiceAddr_Name || "");
      } catch (e) {
        setServiceName("");
      }
    };

    loadName();
  }, [ServiceAddr_Id]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "AR_Tel" || name === "AR_Mobile") {
      let digits = value.replace(/\D/g, "").slice(0, 10);

      if (digits.length === 10) {
        digits = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      } else if (digits.length === 9) {
        digits = `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
      } else if (digits.length > 6) {
        digits = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      } else if (digits.length > 3) {
        digits = `${digits.slice(0, 3)}-${digits.slice(3)}`;
      }

      setFormData((prev) => ({ ...prev, [name]: digits }));
      return;
    }


    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.AR_ContactName.trim()) {
      Swal.fire({ icon: "warning", title: "กรุณากรอกชื่อผู้ติดต่อ", confirmButtonColor: "#E13F57" });
      return;
    }

    if (!formData.AR_Tel.trim()) {
      Swal.fire({ icon: "warning", title: "กรุณากรอกเบอร์โทรศัพท์ 1", confirmButtonColor: "#E13F57" });
      return;
    }

    const phoneRegex = /^[0-9-]{9,13}$/;

    if (!phoneRegex.test(formData.AR_Tel)) {
      Swal.fire({ icon: "warning", title: "เบอร์โทรศัพท์ 1 ไม่ถูกต้อง", text: "กรุณากรอกเบอร์ที่ถูกต้อง", confirmButtonColor: "#E13F57" });
      return;
    }

    if (formData.AR_Mobile && !phoneRegex.test(formData.AR_Mobile)) {
      Swal.fire({ icon: "warning", title: "เบอร์โทรศัพท์ 2 ไม่ถูกต้อง", confirmButtonColor: "#E13F57" });
      return;
    }

    try {
      await onSave({
        ...formData,
        ServiceAddr_Id: formData.ServiceAddr_Id || null,
      });

      // Swal.fire({ icon: "success", title: contact ? "อัปเดตสำเร็จ" : "บันทึกสำเร็จ", confirmButtonColor: "#E13F57" });
      onClose();
    } catch {
      Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด", confirmButtonColor: "#E13F57" });
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center" style={{ zIndex: 1300 }}>
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6">
        <div className="mb-4 border-b pb-2">
          <div className="flex items-center gap-2">
            <PhoneIcon size={30} color="#E13F57" />
            <h3 className="font-bold text-md text-[#E13F57]">ข้อมูลการติดต่อ</h3>
          </div>

          {ServiceAddr_Id && (
            <div className="mt-2">
              <label className="block text-sm mb-1 whitespace-nowrap">สถานที่บริการ</label>
              <input
                type="text"
                value={serviceName}
                readOnly
                className="w-full border rounded px-3 py-2 h-[42px] bg-gray-100 text-gray-600 cursor-not-allowed"
                style={{ fontWeight: 600 }}
              />
            </div>
          )}
        </div>


        <form onSubmit={handleSubmit} className="space-y-4">
          
          <div>
            <label className="block text-sm mb-1">ผู้ติดต่อ <span className="text-red-500">*</span></label>
            <input type="text" name="AR_ContactName" value={formData.AR_ContactName} onChange={handleChange}
              className="w-full border rounded px-3 py-2 h-[42px] focus:ring-2 focus:ring-[#E13F57]" />
          </div>

          {customerType === "corporate" && (
            <div>
              <label className="block text-sm mb-1">ตำแหน่งผู้ติดต่อ</label>
              <input type="text" name="AR_ContactPosition" value={formData.AR_ContactPosition} onChange={handleChange}
                className="w-full border rounded px-3 py-2 h-[42px] focus:ring-2 focus:ring-[#E13F57]" />
            </div>
          )}

          {/*  เบอร์โทร 1 + เบอร์โทร 2 อยู่แถวเดียวกัน */}
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm mb-1 whitespace-nowrap">เบอร์โทรศัพท์ 1 <span className="text-red-500">*</span></label>
              <input type="text" name="AR_Tel" value={formData.AR_Tel} onChange={handleChange} maxLength={12}
                className="w-full border rounded px-3 py-2 h-[42px] focus:ring-2 focus:ring-[#E13F57]" />
            </div>

            <div>
              <label className="block text-sm mb-1 whitespace-nowrap">เบอร์โทรศัพท์ 2</label>
              <input type="text" name="AR_Mobile" value={formData.AR_Mobile} onChange={handleChange} maxLength={12}
                className="w-full border rounded px-3 py-2 h-[42px] focus:ring-2 focus:ring-[#E13F57]" />
            </div>
          </div>

          <div>
            <label className="block text-sm mb-1">อีเมล</label>
            <input type="email" name="AR_Email" value={formData.AR_Email} onChange={handleChange}
              className="w-full border rounded px-3 py-2 h-[42px] focus:ring-2 focus:ring-[#E13F57]" />
          </div>

          <div>
            <label className="block text-sm mb-1">ไลน์</label>
            <input type="text" name="AR_Line" value={formData.AR_Line} onChange={handleChange}
              className="w-full border rounded px-3 py-2 h-[42px] focus:ring-2 focus:ring-[#E13F57]" />
          </div>

          <div className="flex flex-col gap-2 mt-6">
            <button type="submit" className="w-full bg-[#E13F57] hover:bg-[#c53046] text-white py-2 rounded-lg font-bold">
              {contact ? "อัปเดต" : "บันทึก"}
            </button>
            <button type="button" onClick={onClose}
              className="w-full border border-[#E13F57] text-[#E13F57] py-2 rounded-lg font-bold hover:bg-[#ffe6eb]">
              ยกเลิก
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
